import UI from "./UI";

interface SkeletonProps {
  height: string;
  absolute?: boolean;
  className?: string;
}
const Skeleton = ({
  height,
  absolute,
  className,
}: SkeletonProps): React.JSX.Element => {
  return <UI height={height} absolute={absolute} className={className} />;
};

export default Skeleton;
